import React from 'react';
import useNonPalletizedType from 'utils/hooks/useNonPalletizedType';

const defaultPalletPerCountry = {
  UK: 'US_PALLET',
};

const palletTypeText = {
  EU_PALLET: 'Eu',
  CUSTOM_PALLET: 'Sp',
  US_PALLET: 'Us',
  MIXED_PALLET: 'Mx',
  EU_EQUIVALENT: 'Mx',
  BULK: 'Bulk',
  PARCEL: 'Parcel',
  equivalent: 'Eq',
};

const DEFAULT_PALLET_TYPE = 'EU_PALLET';

const PalletsCell = ({
  realPallets,
  equivalentPallets,
  typePallets,
  loadTypes,
  country,
  withEquivalents = true,
  stops,
}) => {
  const container = stops && stops[0] ? { ...stops.filter((s) => s.container_iso_code)[0] } : {};

  const defaultPallet = (!!country && defaultPalletPerCountry[country]) || DEFAULT_PALLET_TYPE;
  const { numberOfPallets, palletText, showSpecialEquivalents } = useNonPalletizedType(
    container,
    realPallets,
    loadTypes,
    typePallets,
    defaultPallet,
    withEquivalents
  );

  if (typeof realPallets === 'undefined') {
    return null;
  }

  const typeOfPallets = palletTypeText[palletText] ? palletTypeText[palletText] : palletText;
  const typeOfPalletsEquivalents = palletTypeText[defaultPallet];

  return (
    <>
      {numberOfPallets} {typeOfPallets}
      {showSpecialEquivalents && (
        <>
          {' '}
          ({equivalentPallets} {typeOfPalletsEquivalents})
        </>
      )}
    </>
  );
};

export default PalletsCell;
